module.exports = __webpack_public_path__ + "static/img/11.0a9d3ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/11.png
// module id = ChW3
// module chunks = 0